/*
 * What Keycloak's sign-in page tells the sign-up page (ui-keycloak-theme's
 * signup.ts): the email they typed, in the fragment so it never reaches a
 * server log, and `?start=google` when they already chose Google. Read once
 * at start and dropped from the address bar.
 */

export interface SignupLink {
    email?: string;
    google: boolean;
}

export function readSignupLink(search: string, hash: string): SignupLink {
    const email = new URLSearchParams(hash.replace(/^#/, '')).get('email')?.trim();
    return {
        email: email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && email.length <= 254 ? email : undefined,
        google: new URLSearchParams(search).get('start') === 'google',
    };
}

/** The address without what readSignupLink took. */
export function stripSignupLink(search: string, hash: string): { search: string; hash: string } {
    const params = new URLSearchParams(search);
    params.delete('start');
    const fragment = new URLSearchParams(hash.replace(/^#/, ''));
    fragment.delete('email');
    const s = params.toString();
    const f = fragment.toString();
    return { search: s ? `?${s}` : '', hash: f ? `#${f}` : '' };
}

let atStart: SignupLink = { google: false };

/** Call once at start, before the address bar is tidied. */
export function captureSignupLink(search: string, hash: string): void {
    atStart = readSignupLink(search, hash);
}

/** What the page was opened with. */
export function signupLinkAtStart(): SignupLink {
    return atStart;
}
